const PERMISSION_KEY= "personalize:nebula_user_profile";
const PAGE_URL = {
    NEBULA_USER_PROFILE_PAGE: "/admin/personalize/nebula-user-profile"
}

export {PERMISSION_KEY, PAGE_URL}

